import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./auth/auth.css";
import { AUTH_BASE_URL } from "./config";
import { setAuthSession } from "./auth/authUtils";


const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  
const handleLogin = async () => {
  setError(null);

  try {
    const res = await fetch(`${AUTH_BASE_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password })
    });


    // 🔥 HANDLE NON-200 RESPONSES
    if (!res.ok) {
      let errorMessage = "Login failed";

      try {
        const errorText = await res.text();

        if (errorText.includes("ACCOUNT_PENDING")) {
          errorMessage = "Your account is pending admin approval.";
        } else if (errorText.includes("DISABLED")) {
          errorMessage = "Your account has been disabled.";
        }
      } catch (_) {
        // ignore parsing errors
      }

      setError(errorMessage);
      return; // 🚨 STOP HERE
    }

    // ✅ SUCCESS
    const data = await res.json();

    if (!data.success) {
      setError(data.message);
      return;
    }
    setAuthSession({
      token: data.token,
      roles: data.roles,
      status: data.status,
    });
    navigate("/app", { replace: true });
  } catch (err) {
    console.error("Login exception:", err);
    setError("Network error. Please try again.");
  }
};


  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-title">Welcome Back</div>
        <div className="auth-subtitle">
          Login to your SignalFly account
        </div>

        {error && <div className="auth-error">{error}</div>}

        <input
          className="auth-input"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          className="auth-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="auth-btn" onClick={handleLogin}>
          Login
        </button>

        <div className="auth-links">
          <div>
            <span onClick={() => navigate("/forgot-password")}>
              Forgot Password?
            </span>
          </div>
          <div style={{ marginTop: "8px" }}>
            Don’t have an account?{" "}
            <span onClick={() => navigate("/signup")}>Sign Up</span>
          </div>
          <div style={{ marginTop: "8px" }}>
            Back to{" "}
            <span onClick={() => navigate("/")}>Home</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
